export default "__VITE_ASSET__BvYmoWU7__"